import { Segment, Icon } from "semantic-ui-react";
import SunEditor from "suneditor-react";
import { useCallback, useEffect, useState } from "react";
import { countImages, getTextLength, getTotalVideoOrLink, getPostById } from "./MeBroadcastUtils";

// Serializers
import BroadcastPostSerializer from "issara-sdk/types/BroadcastPostSerializer_apps_PRX";

// Types
import { AllowedCondition, RunSequence, COLLECTION } from "./MeFormType";
import { UploadBeforeHandler, UploadBeforeReturn, UploadInfo } from "suneditor-react/dist/types/upload";
import { BroadcastMode } from "./MeCastType";

type PanelEditorBroadcastProps = {
  // config
  mode: BroadcastMode;
  // func & callbacl
  // runSequence: RunSequence;
  onChangeContent: (content: string) => Promise<void>;
  onImageUpload: (
    targetImgElement: HTMLImageElement,
    index: number,
    state: "create" | "update" | "delete",
    imageInfo: UploadInfo<HTMLImageElement>,
    remainingFilesCount: number
  ) => void;
  onImageUploadBefore: (
    files: File[],
    info: object,
    uploadHandler: UploadBeforeHandler
  ) => UploadBeforeReturn | undefined;
  onImageUploadError: (errorMessage: string, result: any) => void;
  onResizeEditor: (height: number, prevHeight: number) => void;
  // data
  keyEditor?: string;
  content: string;
  allowedSend: AllowedCondition;
  selectedPostBroadcast?: BroadcastPostSerializer | null;
  showWarnings: boolean;
};

const PanelEditorBroadcast = (props: PanelEditorBroadcastProps) => {
  const { content } = props;

  const handleChangeLocal = (value: string) => {
    props.onChangeContent(value);
  };

  return (
    <Segment
      style={{
        backgroundColor: "var(--primary-select-background)",
        padding: "4px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflowX: "hidden",
        borderRadius: 0
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
        <div>
          {props.showWarnings && (
            <div style={{ color: "red", alignItems: "center" }}>
              <Icon name="warning" />
              <label>This post exceeds the allowed limits. Please adjust and try again.</label>
            </div>
          )}
        </div>

        <div style={{ display: "flex", gap: "20px" }}>
          <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
            <Icon
              size="large"
              color={props.allowedSend.tooManyVideos ? "red" : "grey"}
              name="youtube play"
            />
            <label style={{ color: props.allowedSend.tooManyVideos ? "red" : "black" }}>
              {getTotalVideoOrLink(content)}
              <span style={{ color: "black" }}>/1</span>
            </label>
          </div>
          <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
            <Icon
              size="large"
              color={props.allowedSend.tooManyImages ? "red" : "grey"}
              name="image outline"
            />
            <label style={{ color: props.allowedSend.tooManyImages ? "red" : "black" }}>
              {countImages(content)}
              <span style={{ color: "black" }}>/2</span>
            </label>
          </div>
          <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
            <Icon size="large" color={props.allowedSend.tooLongText ? "red" : "grey"} name="chat" />
            <label style={{ color: props.allowedSend.tooLongText ? "red" : "black" }}>
              {getTextLength(content)}
              <span style={{ color: "black" }}>/1000</span>
            </label>
          </div>
        </div>
      </div>

      <SunEditor
        key={props.keyEditor} // prevent unmounting
        height="100%"
        onChange={handleChangeLocal}
        onImageUpload={props.onImageUpload}
        onImageUploadBefore={props.onImageUploadBefore}
        onImageUploadError={props.onImageUploadError}
        onResizeEditor={props.onResizeEditor}
        setContents={content}
        setOptions={{
          buttonList: props.mode === "VIEW" ? [] : [
            ["formatBlock"],
            ["blockquote"],
            ["bold", "underline", "italic", "strike"],
            ["fontColor", "hiliteColor"],
            ["align", "list"],
            ["outdent", "indent"],
            ["horizontalRule", "image", "video", "link"],
            ["removeFormat"],
          ],
          defaultTag: "div",
          minHeight: "200px",
          showPathLabel: false,
        }}
        readOnly={props.mode === "VIEW"}
      />
    </Segment>
  );
};

export default PanelEditorBroadcast;
